module.exports = "/_next/static/images/44f535241c356a3b26d78d6bb47d8d2f-payment_slider.png.webp";